<template>
  <base-modal v-if="isModalOpen" @close="toggleModal">
      <form @submit.prevent="contactCoach" class="p-2">
          <div>
            <div class="mb-6">
              <h1 class="text-2xl leading-6 font-medium text-gray-900">
                Contact Coach
              </h1>
            </div>
            <div class="" :class="{ 'bg-red-200 p-2': !email.isValid }">
              <label for="email" class="block text-sm font-medium text-gray-700">
                Email
              </label>
              <div class="mt-1">
                <input type="email"
                       name="email"
                       v-model.trim="email.val"
                       @blur="clearValidity('email')"
                       id="email"
                       class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full
                sm:text-sm border-gray-300 rounded-md" />
              </div>
            </div>
            <div class="mt-2" :class="{ 'bg-red-200 p-2': !message.isValid }">
              <label for="about" class="block text-sm font-medium text-gray-700">
                Message
              </label>
              <div class="mt-1">
                <textarea
                    id="message"
                    name="message"
                    v-model.trim="message.val"
                    @blur="clearValidity('message')"
                    rows="5"
                    class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" />
              </div>
            </div>
            <div class="flex justify-center mt-2">
              <button type="submit"
                      class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-500 hover:bg-blue-700
                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                Send Message
              </button>
            </div>
          </div>
      </form>
  </base-modal>
</template>

<script>

export default {
  name: "ContactCoach",
  data(){
    return{
      email: {
        val: '',
        isValid: true,
      },
      message: {
        val: '',
        isValid: true,
      },
      formIsValid: true,
      isModalOpen: true,
    };
  },
  methods: {
    contactCoach(){
      //console.log('form submitted');
      this.validateForm();

      if (!this.formIsValid) {
        return;
      }

      //submit data
      const formData = {
        coachId: this.$route.params.id, //todo add coach id from route params
        email: this.email.val,
        message: this.message.val,
      }

      //todo call vuex
      //console.log('form data', formData);
      this.$store.dispatch('requests/contactCoach', formData);

      //redirect after success
      this.$router.replace('/coaches/' + formData.coachId);

    },
    validateForm(){
      this.formIsValid = true;

      if (this.email.val === '') {
        this.email.isValid = false;
        this.formIsValid = false;
      }
      if (this.message.val === '') {
        this.message.isValid = false;
        this.formIsValid = false;
      }
    },
    clearValidity(input) {
      this[input].isValid = true;
    },
    toggleModal(){
      this.isModalOpen = !this.isModalOpen;
      //console.log('toggle modal', this.isModalOpen);
    },
  }
}
</script>
